import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_CHECK_ITEM_LIST = {
    type: 'CHECK_ITEM_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
        checkDate: '',
    },
};

let callCheckItemListGet = (checkId, filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    filter.pg = pg;
    Api.get('/check-items/' + checkId + '?' + (new URLSearchParams(filter)).toString()).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_CHECK_ITEM_LIST.payload.rows = data.rows
        ACTION_CHECK_ITEM_LIST.payload.total = data.total
        ACTION_CHECK_ITEM_LIST.payload.pagination = data.pagination
        ACTION_CHECK_ITEM_LIST.payload.checkDate = data.checkDate
        dispatch(ACTION_CHECK_ITEM_LIST)
    })
}

export { callCheckItemListGet, ACTION_CHECK_ITEM_LIST }